export const appsUserInfoMergeDuplicateUsersRecordDatatable =
  "/apps/user_info/merge_duplicate_users_record_datatable";
